var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        "no-primary-button": "",
        closeButtonText: _vm._f("gettext")("Close"),
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "ContractServiceFee",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded && !_vm.noHeader
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal, stretch: "" } },
            [
              _c(
                "ItpForm",
                {
                  ref: "mainForm",
                  staticClass: "row",
                  attrs: { id: _vm.formId, name: _vm.formName },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpCol",
                    [
                      _vm.displayParent && _vm.item.contract
                        ? _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "contract",
                                label: _vm._f("pgettext")(
                                  "Contract",
                                  "ContractServiceEditor"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                contentClass:
                                  "form-control form-control-readonly"
                              }
                            },
                            [
                              _c("UcContractMiniCard", {
                                attrs: {
                                  item: _vm.item.contract,
                                  "no-link": ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayParent && _vm.item.contract_service
                        ? _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "contract",
                                label: _vm._f("pgettext")(
                                  "Service",
                                  "ContractServiceEditor"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                contentClass:
                                  "form-control form-control-readonly"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.item.contract_service.name) +
                                    "\n          "
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.displayParent ? _c("hr") : _vm._e(),
                      _vm._v(" "),
                      _c("FieldsetContractServiceFee", {
                        attrs: { item: _vm.item }
                      }),
                      _vm._v(" "),
                      _c(
                        "DIV",
                        { staticClass: "offset-3" },
                        [
                          _vm.inlineCommands
                            ? _c("ItpButton", {
                                attrs: {
                                  text: _vm._f("pgettext")("Save", "Button"),
                                  disabled:
                                    !_vm.forms[_vm.formName] ||
                                    !_vm.forms[_vm.formName].submittable,
                                  type: "submit",
                                  form: _vm.formId,
                                  variant: "primary",
                                  icon: "fa-save",
                                  spinning: _vm.actions.save.isRunning
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded && !_vm.noFooter
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Save", "Button"),
                  disabled:
                    !_vm.forms[_vm.formName] ||
                    !_vm.forms[_vm.formName].submittable,
                  type: "submit",
                  form: _vm.formId,
                  variant: "primary",
                  icon: "fa-save",
                  spinning: _vm.actions.save.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: { text: _vm._f("gettext")("Close"), variant: "default" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }